import type { MovingBall } from "../shared-sortaballs/use-ball-game"
import type { CommittedMove, GameState } from "./logic"

import { useBallGame } from "../shared-sortaballs/use-ball-game"
import { SA_CAPACITY } from "./logic"

// Sortaballs' UI state hook — the shared reducer engine bound to this game's
// capacity. The initial board is supplied per puzzle, never a fixed default;
// initialMoves replay a restored session so undo/reset keep their history.
export const useSortaballs = (
  initialBoard: GameState,
  capacity: number | readonly number[] = SA_CAPACITY,
  initialMoves: CommittedMove[] = [],
)=> useBallGame(initialBoard, capacity, initialMoves)

export type { MovingBall }
